function PisFragmentsController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.dataLoading = true;
    stateService.getFragments(ctrl.workspaceId).then(data => {
      ctrl.fragments = data;
      ctrl.dataLoading = false;
    });
    ctrl.editMode = false;
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.fragment;
  };

  ctrl.onDelete = event => {
    stateService.deleteFragment(ctrl.workspaceId, event.fragmentId).then(
      response => {
        stateService.getFragments(ctrl.workspaceId).then(data => (ctrl.fragments = data));
        toasterService.success('toaster.pis-event', 'toaster.pis-delete-fragment-successful');
      },
      function(e) {
        toasterService.error('toaster.pis-event', 'toaster.pis-delete-fragment-failure');
        console.log(e);
      }
    );
  };

  ctrl.onFormSubmit = async (event) => {
    ctrl.fragments = await stateService.getFragments(ctrl.workspaceId);
    ctrl.editMode = event.mode;
    ctrl.selection = null;
  };

  ctrl.setEditMode = () => {
      ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
      ctrl.editMode = false;
      stateService.getFragments(ctrl.workspaceId).then(data => (ctrl.fragments = data));
      ctrl.selection = null;
  };
}

angular.module('pis-tool.module').controller('PisFragmentsController', PisFragmentsController);
